import { motion } from "framer-motion";
import { Rocket } from "lucide-react";

const platforms = [
  {
    name: "VERIXAE",
    desc: "Piattaforma HR con AI: Presenze, Calendario, Rimborsi, Firma Digitale, Cedolini e Dashboard",
    tagline: "HR INTELLIGENCE",
    img: "https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/b0l7lca9_ChatGPT%20Image%2027%20mag%202026%2C%2017_11_21.png",
    color: "#6366F1",
    type: "image",
    services: [
      "Presenze QR + GPS",
      "Calendario AI",
      "Rimborsi spese OCR",
      "Firma digitale eIDAS",
      "AI Insights GPT-5",
      "Cedolini & Paghe",
      "Rapportino Ore AI",
      "Dashboard AI",
    ],
  },
  {
    name: "SAN MARINO MARKET",
    desc: "Il Mercato del Titano. Compra, Vendi, Baratta.",
    tagline: "MARKETPLACE",
    img: "https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/65hp5wdj_Contemporary%20Emblem%20Logo%20for%20SAN%20MARINO%20MARKET.png",
    color: "#E97A1F",
    type: "image",
    screenshot: "https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/oel4alv1_ChatGPT%20Image%206%20mag%202026%2C%2012_56_21.png",
  },
  {
    name: "LIFELINKE",
    desc: "Piattaforma per le Emergenze",
    tagline: "AIUTO / INTERVENTO / SPERANZA",
    img: "https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/bv6ar9bu_17%20apr%202026%2C%2009_06_17.png",
    color: "#FF3366",
    type: "image",
  },
  {
    name: "COMPLYO",
    desc: "App per Indagini di Certificazione del Marchio CE",
    tagline: "CERTIFICAZIONE CE",
    img: "https://customer-assets.emergentagent.com/job_ninfa-redesign/artifacts/toyai1uv_ChatGPT%20Image%2013%20apr%202026%2C%2015_42_20.png",
    color: "#22C55E",
    type: "image",
  },
  {
    name: "AI DAMAGE",
    desc: "Piattaforma di Rilevazione dei Danni",
    tagline: "INTELLIGENZA ARTIFICIALE",
    img: null,
    color: "#3B82F6",
    type: "text",
  },
  {
    name: "SOCIAL NETWORK",
    desc: "Il futuro della connessione sociale",
    tagline: "COMING SOON",
    img: null,
    color: "#A855F7",
    type: "coming_soon",
  },
];

function PlatformCard({ platform }) {
  const isComing = platform.type === "coming_soon";

  return (
    <div className="w-[340px] sm:w-[400px] flex-shrink-0 group">
      <div
        className="relative h-[400px] border border-white/10 bg-[#0d0d0d] overflow-hidden transition-all duration-500 hover:border-opacity-60"
        style={{ borderColor: `${platform.color}30` }}
      >
        {/* Logo / Image area */}
        <div className="relative h-[260px] flex items-center justify-center overflow-hidden bg-[#0a0a0f]">
          {platform.type === "image" && platform.img ? (
            <img
              src={platform.img}
              alt={platform.name}
              className="w-full h-full object-contain p-6 transition-transform duration-500 group-hover:scale-105"
            />
          ) : platform.type === "text" ? (
            <div className="text-center p-8">
              <div
                className="text-6xl font-heading font-black tracking-tighter mb-3"
                style={{ color: platform.color }}
              >
                AI
              </div>
              <div className="text-4xl font-heading font-black tracking-tighter text-white">
                DAMAGE
              </div>
              <div className="mt-4 flex items-center justify-center gap-2">
                <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: platform.color }} />
                <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: platform.color, animationDelay: "0.2s" }} />
                <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: platform.color, animationDelay: "0.4s" }} />
              </div>
            </div>
          ) : (
            <div className="text-center p-8 relative">
              <Rocket size={48} style={{ color: platform.color }} className="mx-auto mb-4 animate-float" />
              <div className="text-3xl font-heading font-black tracking-tighter text-white">
                SOCIAL
              </div>
              <div className="text-3xl font-heading font-black tracking-tighter" style={{ color: platform.color }}>
                NETWORK
              </div>
              <div
                className="absolute inset-0 opacity-10"
                style={{
                  background: `radial-gradient(circle at center, ${platform.color}, transparent 70%)`,
                }}
              />
            </div>
          )}
          <div
            className="absolute bottom-0 left-0 right-0 h-20 pointer-events-none"
            style={{
              background: `linear-gradient(to top, #0d0d0d, transparent)`,
            }}
          />
        </div>

        {/* Info area */}
        <div className="p-5 relative">
          {isComing && (
            <span
              className="inline-block text-[10px] font-mono font-bold tracking-[0.3em] px-3 py-1 mb-2"
              style={{ backgroundColor: `${platform.color}20`, color: platform.color }}
            >
              COMING SOON
            </span>
          )}
          <h3 className="font-heading text-xl font-bold tracking-tight">{platform.name}</h3>
          <p className="text-[#A3A3A3] text-sm mt-1 font-body">{platform.desc}</p>
          {platform.services && (
            <div className="flex flex-wrap gap-1 mt-3">
              {platform.services.slice(0, 4).map((s, i) => (
                <span key={i} className="text-[9px] font-mono tracking-wider px-2 py-0.5 border" style={{ borderColor: `${platform.color}40`, color: platform.color }}>
                  {s}
                </span>
              ))}
            </div>
          )}
          {!isComing && !platform.services && (
            <span
              className="inline-block font-mono text-[10px] tracking-[0.2em] mt-3"
              style={{ color: platform.color }}
            >
              {platform.tagline}
            </span>
          )}
          <div
            className="absolute bottom-0 left-5 right-5 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            style={{ backgroundColor: platform.color }}
          />
        </div>
      </div>
    </div>
  );
}

export default function PlatformsSection() {
  const doubled = [...platforms, ...platforms];

  return (
    <section data-testid="platforms-section" id="piattaforme" className="py-16 sm:py-24 lg:py-32 bg-[#050505] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 mb-8 sm:mb-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="font-mono text-xs tracking-[0.2em] text-[#FF3366] uppercase">
            LE NOSTRE PIATTAFORME
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-tight">
            Siamo gli inventori <span className="text-[#A3A3A3]">di</span>
          </h2>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="overflow-hidden"
      >
        <div className="animate-carousel-left" style={{ animationDuration: "50s" }}>
          <div className="flex gap-6" style={{ width: "max-content" }}>
            {doubled.map((p, i) => (
              <PlatformCard key={i} platform={p} />
            ))}
          </div>
        </div>
      </motion.div>

      {/* Static cards below for visibility */}
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 mt-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-wrap gap-3"
        >
          {platforms.map((p, i) => (
            <span
              key={i}
              data-testid={`platform-tag-${i}`}
              className="border px-4 py-2 font-mono text-xs tracking-wider transition-colors cursor-default"
              style={{
                borderColor: `${p.color}30`,
                color: p.color,
              }}
            >
              {p.name}
              {p.type === "coming_soon" && " — COMING SOON"}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
